import { ActionTypes } from './actions';
import { TempSharingSettingsState, INITIAL_STATE } from './state';
import { ReduxAction } from '../actions';
/**
 * temporarily ignore LOGOUT_SUCCESS since Auth/actions is still in js
 * and the actions are being used in a lot of places
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { LOGOUT_SUCCESS } from '../Auth/actions';

export const TempSharingSettings = (
  state = INITIAL_STATE,
  action: ReduxAction
): TempSharingSettingsState => {
  switch (action.type) {
    case ActionTypes.UPDATE_TEMP_SHARING_SETTINGS:
      return {
        ...state,
        [action.updateType]: action.value,
      };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    case LOGOUT_SUCCESS:
    case ActionTypes.RESET_TEMP_SHARING_SETTINGS:
      return INITIAL_STATE;
    default:
      return state;
  }
};
